<div class="search-widget-holder">
  <div
    class="search-widget-wrapper"
    [ngClass]="{ 'search-widget-wrapper--sticky': isSticky }"
    [style.margin-top]="isSticky && !isMobile ? topmargin + 'px' : null"
  >
    <div
      #searchWidget
      class="search-widget"
      [ngStyle]="{ 'margin-top': !isSticky && !isMobile ? topmargin + 'px' : null }"
    >
      <div *ngIf="!isSticky || isMobile" class="header__tabs">
        <div
          class="header__tab"
          [ngClass]="tabIndex === 1 ? 'header__tab--active' : 'header__tab'"
          (click)="changeTab(1)"
        >
          <div class="icon__box">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_30908_15750)">
                <path
                  d="M3 5C3.53125 5 4 5.46875 4 6V14H11V9C11 8.46875 11.4375 8 12 8H19C20.6562 8 22 9.34375 22 11V18C22 18.5625 21.5312 19 21 19C20.4375 19 20 18.5625 20 18V17H13H12H4V18C4 18.5625 3.53125 19 3 19C2.4375 19 2 18.5625 2 18V6C2 5.46875 2.4375 5 3 5ZM7.5 8C8.375 8 9.1875 8.5 9.65625 9.25C10.0938 10.0312 10.0938 11 9.65625 11.75C9.1875 12.5312 8.375 13 7.5 13C6.59375 13 5.78125 12.5312 5.3125 11.75C4.875 11 4.875 10.0312 5.3125 9.25C5.78125 8.5 6.59375 8 7.5 8Z"
                  fill="currentColor"
                />
              </g>
              <defs>
                <clipPath id="clip0_30908_15750">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
          <span class="tab__title">{{ 'search-widget.stays' | translate }}</span>
        </div>
        <div class="header__tab" [ngClass]="tabIndex === 2 ? 'header__tab--active' : ''" (click)="changeTab(2)">
          <div class="icon__box">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_30908_15754)">
                <path
                  d="M10.3125 5.21875V7.75H13.6875V5.21875C13.6875 5.07812 13.5469 4.9375 13.4062 4.9375H10.5938C10.418 4.9375 10.3125 5.07812 10.3125 5.21875ZM8.625 7.75V5.21875C8.625 4.16406 9.50391 3.25 10.5938 3.25H13.4062C14.4609 3.25 15.375 4.16406 15.375 5.21875V7.75H16.5C17.7305 7.75 18.75 8.76953 18.75 10V17.875C18.75 19.1406 17.7305 20.125 16.5 20.125V20.4062C16.5 20.8984 16.1133 21.25 15.6562 21.25C15.1641 21.25 14.8125 20.8984 14.8125 20.4062V20.125H9.1875V20.4062C9.1875 20.8984 8.80078 21.25 8.34375 21.25C7.85156 21.25 7.5 20.8984 7.5 20.4062V20.125C6.23438 20.125 5.25 19.1406 5.25 17.875V10C5.25 8.76953 6.23438 7.75 7.5 7.75H8.625ZM7.5 9.4375C7.18359 9.4375 6.9375 9.71875 6.9375 10V17.875C6.9375 18.1914 7.18359 18.4375 7.5 18.4375H16.5C16.7812 18.4375 17.0625 18.1914 17.0625 17.875V10C17.0625 9.71875 16.7812 9.4375 16.5 9.4375H7.5ZM8.625 11.9688C8.625 11.5117 8.97656 11.125 9.46875 11.125H14.5312C14.9883 11.125 15.375 11.5117 15.375 11.9688C15.375 12.4609 14.9883 12.8125 14.5312 12.8125H9.46875C8.97656 12.8125 8.625 12.4609 8.625 11.9688ZM8.625 15.9062C8.625 15.4492 8.97656 15.0625 9.46875 15.0625H14.5312C14.9883 15.0625 15.375 15.4492 15.375 15.9062C15.375 16.3984 14.9883 16.75 14.5312 16.75H9.46875C8.97656 16.75 8.625 16.3984 8.625 15.9062Z"
                  fill="currentColor"
                />
              </g>
              <defs>
                <clipPath id="clip0_30908_15754">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
          <span class="tab__title">{{ 'search-widget.your-booking' | translate }}</span>
        </div>
      </div>
      <div *ngIf="tabIndex === 1" class="search-widget__container">
        <h3 *ngIf="isMobile" class="booking-form-title">
          <ng-container *ngIf="!isMobile">
            {{ 'home-main-headline' | translate }}
          </ng-container>
          <ng-container *ngIf="isMobile">
            {{ 'home-find-a-suite' | translate }}
          </ng-container>
        </h3>
        <div class="form inner-booking-widget">
          <div class="search-widget__form-item">
            <app-city-picker
              [classList]="'inner inner-listings'"
              [parentShadowRoot]="searchWidgetShadowRoot"
              (selectedCity)="onCitySelected($event)"
              (showCityPickerEvent)="showHideCityPicker($event)"
            />
          </div>
          <div class="search-widget__form-item">
            <app-date-picker
              [showCalendar]="showCalendar"
              [calendar]="calendar"
              [currentLang]="currentLang"
              [selectedDatesLabel]="selectedDatesLabel"
              [selectedDates]="selectedDates"
              [isSearchBar]="true"
              [horizontalLayout]="false"
              [classList]="'inner inner-listings'"
              (shouldShowCalendar)="showHideCalendar($event)"
            />
            <app-calendar
              #calendar
              class="listings__date-calendar"
              [cityId]="cityId"
              [hidden]="!showCalendar"
              [isHidden]="!showCalendar"
              [dateRange]="selectedDates"
              (bookedDates)="processBookedDates($event)"
              (hideCalendar)="showHideCalendar($event)"
            />
          </div>
          <div class="search-widget__form-item">
            <app-guest-picker
              [isSearchWidget]="true"
              [openModalOnMobile]="!isElements"
              [adultsNum]="adults"
              [roomsNum]="rooms"
              [childrenAges]="childrenAges"
              [updateGuestWithoutRequest]="true"
              [parentShadowRoot]="searchWidgetShadowRoot"
              [classList]="'inner'"
              (guestsData)="updateGuestData($event)"
              (ageSelectionStatus)="onAgeSelection($event)"
              (dropdownStatus)="onDropdownStatus($event)"
              (trackClickEvent)="trackClickEvent($event)"
            />
          </div>
        </div>
        <button
          type="button"
          id="qa_search-button"
          class="btn--search-widget-search button"
          (click)="submitSearchRequest($event)"
        >
          {{ 'home-main-search-btn' | translate }}
        </button>
      </div>
      <div *ngIf="tabIndex === 2" class="guest-checkin">
        <div class="guest-checkin__header" [ngClass]="isSticky ? 'guest-checkin--sticky' : ''">
          <p *ngIf="tabIndex === 2" class="tab__subtitle">
            {{ 'header-menu-checkin' | translate }} / {{ 'bdp.form-title' | translate }}
          </p>
        </div>
        <form class="checkin__form" [formGroup]="bookingRefForm">
          <div class="form-group form-group--checkin form-group--first">
            <input
              id="last-name-reservation"
              data-hj-suppress
              type="text"
              class="!border-md !border-keyboard-focus"
              required
              formControlName="lastName"
              tabindex="1"
              [ngClass]="{ error: bookingRefInfoSubmitted && bookingRefForm.controls.lastName.errors }"
            />
            <label class="site__label" for="last-name-reservation">
              {{ 'reservation-form.last-name' | translate }}
            </label>
            <span
              *ngIf="bookingRefInfoSubmitted && bookingRefForm.controls.lastName.errors"
              class="help-text help-text--error"
            >
              {{ 'booking-reference.last-name-error' | translate }}
            </span>
          </div>
          <div class="form-group form-group--checkin form-group--second">
            <div class="form-group__input-container">
              <input
                id="booking-reference"
                data-hj-suppress
                type="text"
                required
                formControlName="reservationId"
                tabindex="2"
                class="!border-md !border-keyboard-focus"
                [ngClass]="{ error: bookingRefInfoSubmitted && bookingRefForm.controls.reservationId.errors }"
              />
              <label class="site__label" for="booking-reference">
                {{ 'reservation-form.booking-reference' | translate }}
              </label>
              <app-reference-info [text]="'booking-reference.tooltip'" [additionalClass]="'dark'" />
            </div>
            <span
              *ngIf="bookingRefInfoSubmitted && bookingRefForm.controls.reservationId.errors"
              class="help-text help-text--error"
            >
              {{ 'booking-reference.booking-reference-error' | translate }}
            </span>
          </div>
          <button
            type="submit"
            id="qa_search-button"
            class="button button--search"
            [disabled]="isFetching"
            (click)="getGuestHubInfo()"
          >
            <span [class.invisible]="isFetching">{{ 'submit' | translate }}</span>
            <app-loading-indicator *ngIf="isFetching" class="absolute" />
          </button>
        </form>
        <span
          *ngIf="bookingRefInfoSubmitted && bookingRefForm.errors?.authentication?.message"
          class="help-text help-text--error"
        >
          {{ 'search-widget.unauthorized-credentials' | translate }}
        </span>
      </div>
    </div>
  </div>
  <div *ngIf="title && isMobile" class="search-widget-title">
    {{ title }}
  </div>
</div>
<div *ngIf="isElements" class="modal-placeholder"></div>
